import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="9" height="964" viewBox="0 0 9 964" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" {...props}><path d="M7.54 963C5.4 591.22 2.92 233.42 1 10.46m3.58 932.48C1.18 644.57.1 321.74 5.4 1.1" stroke="#000" strokeWidth="2" strokeLinecap="round" /></svg>);